import { render, staticRenderFns } from "./NotificationSchedule.vue?vue&type=template&id=1faa0ecc&scoped=true&"
import script from "./NotificationSchedule.vue?vue&type=script&lang=js&"
export * from "./NotificationSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa0ecc",
  null
  
)

export default component.exports